// Single place that raises the "no permission" toaster, so the message text and
// notification style live in ONE spot instead of being copy-pasted at every guard
// / gated action. Pass a custom `message` to override for a specific context
// (e.g. an edit-only guard); omit it for the default page-access message.
//
//   import { notifyNoAccess } from '../rbac';
//   notifyNoAccess();                         // "You do not have permission..."
//   notifyNoAccess('You cannot edit this.');  // custom

import displayNotification from '../utils/notification';

// Matches the existing V1 RBAC wording ("You do not have permission to ...") used by
// the Dispatch Board / Driver Shift / Shift Report edit guards, applied to page access.
export const NO_ACCESS_MESSAGE = 'You do not have permission to access this page.';

// displayNotification(description, message, type) — we surface the text as the
// notification title (message) and leave the description empty, matching the
// existing warning-toast usage across the app.
export const notifyNoAccess = (message = NO_ACCESS_MESSAGE) => displayNotification('', message, 'warning');

export default notifyNoAccess;
